import { updateObject } from "utils/helpers/updateObject";
import { DcddUsers, initialState } from "./state";
import {
  actionTypes,
  BulkRegistrationFailAction,
  BulkRegistrationRequestAction,
  BulkRegistrationSuccessAction,
  CheckForExistingDcddUserByEmailFailAction,
  CheckForExistingDcddUserByEmailRequestAction,
  CheckForExistingDcddUserByEmailSuccessAction,
  CheckForExistingDcddUserByMobileFailAction,
  CheckForExistingDcddUserByMobileRequestAction,
  CheckForExistingDcddUserByMobileSuccessAction,
  CreateDcddUserFailAction,
  CreateDcddUserRequestAction,
  CreateDcddUserSuccessAction,
  DcddUserActions,
  FetchDcddActiveUsersFailureAction,
  FetchDcddActiveUsersRequestAction,
  FetchDcddActiveUsersSuccessAction,
  FetchDcddUserProfileByUserIdFailureAction,
  FetchDcddUserProfileByUserIdRequestAction,
  FetchDcddUserProfileByUserIdSuccessAction,
  FetchDcddUsersByDateRangeFailureAction,
  FetchDcddUsersByDateRangeRequestAction,
  FetchDcddUsersByDateRangeSuccessAction,
  FetchDcddUsersFailureAction,
  FetchDcddUsersRequestAction,
  FetchDcddUsersSuccessAction,
  FetchDzongkhagFailureAction,
  FetchDzongkhagRequestAction,
  FetchDzongkhagSuccessAction,
  FetchEccdFailureAction,
  FetchEccdRequestAction,
  FetchEccdSuccessAction,
  FetchGradesFailureAction,
  FetchGradesRequestAction,
  FetchGradesSuccessAction,
  FetchSchoolsFailureAction,
  FetchSchoolsRequestAction,
  FetchSchoolsSuccessAction,
  ResetDcddDetails,
  stateStatusType,
  UpdateDcddUserFailAction,
  UpdateDcddUserPasswordFailAction,
  UpdateDcddUserPasswordRequestAction,
  UpdateDcddUserPasswordSuccessAction,
  UpdateDcddUserRequestAction,
  UpdateDcddUserStatusFailAction,
  UpdateDcddUserStatusRequestAction,
  UpdateDcddUserStatusSuccessAction,
  UpdateDcddUserSuccessAction,
} from "./actionType";

//FetchDcddUserRequest
const FetchDcddUserRequest = (
  state: DcddUsers,
  action: FetchDcddUsersRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchDcddUserSuccess = (
  state: DcddUsers,
  action: FetchDcddUsersSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      dcddUsers: action.payload,
    },
  });
};
const FetchDcddUserFail = (
  state: DcddUsers,
  action: FetchDcddUsersFailureAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//FetchDcddActiveUserRequest
const FetchDcddActiveUserRequest = (
  state: DcddUsers,
  action: FetchDcddActiveUsersRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchDcddActiveUserSuccess = (
  state: DcddUsers,
  action: FetchDcddActiveUsersSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      dcddActiveUsers: action.payload,
    },
  });
};
const FetchDcddActiveUserFail = (
  state: DcddUsers,
  action: FetchDcddActiveUsersFailureAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//FetchDcddUserByDateRangeRequest
const FetchDcddUserByDateRangeRequest = (
  state: DcddUsers,
  action: FetchDcddUsersByDateRangeRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchDcddUserByDateRangeSuccess = (
  state: DcddUsers,
  action: FetchDcddUsersByDateRangeSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      filteredDcddUser: action.payload,
    },
  });
};
const FetchDcddUserByDateRangeFail = (
  state: DcddUsers,
  action: FetchDcddUsersByDateRangeFailureAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//FetchDcddUserProfileRequest
const FetchDcddUserProfileRequest = (
  state: DcddUsers,
  action: FetchDcddUserProfileByUserIdRequestAction
) => {
  return updateObject(state, {
    dcddUserProfileState: {
      ...state.dcddUserProfileState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchDcddUserProfileSuccess = (
  state: DcddUsers,
  action: FetchDcddUserProfileByUserIdSuccessAction
) => {
  return updateObject(state, {
    dcddUserProfileState: {
      ...state.dcddUserProfileState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      dcddUserProfile: action.payload,
    },
  });
};
const FetchDcddUserProfileFail = (
  state: DcddUsers,
  action: FetchDcddUserProfileByUserIdFailureAction
) => {
  return updateObject(state, {
    dcddUserProfileState: {
      ...state.dcddUserProfileState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//CheckForExistingDcddUserByMobile
const checkForExistingUserByMobileRequest = (
  state: DcddUsers,
  action: CheckForExistingDcddUserByMobileRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      status: null,
      isLoading: true,
    },
  });
};
const checkForExistingUserByMobileSuccess = (
  state: DcddUsers,
  action: CheckForExistingDcddUserByMobileSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      error: null,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
  });
};

const checkForExistingUserByMobileFail = (
  state: DcddUsers,
  action: CheckForExistingDcddUserByMobileFailAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      status: stateStatusType.FAILED,
      isLoading: false,
      error: action.payload,
    },
  });
};

//CheckForExistingDcddUserByMobile
const checkForExistingUserByEmailRequest = (
  state: DcddUsers,
  action: CheckForExistingDcddUserByEmailRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      status: null,
      isLoading: true,
    },
  });
};
const checkForExistingUserByEmailSuccess = (
  state: DcddUsers,
  action: CheckForExistingDcddUserByEmailSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      error: null,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
  });
};

const checkForExistingUserByEmailFail = (
  state: DcddUsers,
  action: CheckForExistingDcddUserByEmailFailAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

const resetDcddDetails = (state: DcddUsers, action: ResetDcddDetails) => ({
  ...state,
  dcddUserState: { ...initialState.dcddUserState },
  genericDcddUserState: { ...initialState.genericDcddUserState },
  dcddUserProfileState: { ...initialState.dcddUserProfileState },
});

//fetch dzongkhag
const FetchDzongkhagRequest = (
  state: DcddUsers,
  action: FetchDzongkhagRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchDzongkhagSuccess = (
  state: DcddUsers,
  action: FetchDzongkhagSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      fetchDzongkhag: action.payload,
    },
  });
};
const FetchDzongkhagFail = (
  state: DcddUsers,
  action: FetchDzongkhagFailureAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//fetch Schools
const FetchSchoolsRequest = (
  state: DcddUsers,
  action: FetchSchoolsRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchSchoolsSuccess = (
  state: DcddUsers,
  action: FetchSchoolsSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      fetchSchool: action.payload,
    },
  });
};
const FetchSchoolsFail = (
  state: DcddUsers,
  action: FetchSchoolsFailureAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//fetch Eccd
const FetchEccdRequest = (state: DcddUsers, action: FetchEccdRequestAction) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchEccdSuccess = (state: DcddUsers, action: FetchEccdSuccessAction) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      fetchEccd: action.payload,
    },
  });
};
const FetchEccdFail = (state: DcddUsers, action: FetchEccdFailureAction) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//fetch Grades
const FetchGradesRequest = (
  state: DcddUsers,
  action: FetchGradesRequestAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchGradesSuccess = (
  state: DcddUsers,
  action: FetchGradesSuccessAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      fetchGrade: action.payload,
    },
  });
};
const FetchGradesFail = (
  state: DcddUsers,
  action: FetchGradesFailureAction
) => {
  return updateObject(state, {
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//createDcdduser
const createDcddUserRequest = (
  state: DcddUsers,
  action: CreateDcddUserRequestAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const createDcddUserSuccess = (
  state: DcddUsers,
  action: CreateDcddUserSuccessAction
) => {
  const existingUser = state.dcddUserState.dcddUsers ?? [];
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    dcddUserState: {
      ...state.dcddUserState,
      dcddUsers: [...existingUser, action.payload],
    },
  });
};

const createDcddUserFail = (
  state: DcddUsers,
  action: CreateDcddUserFailAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//updateDcddUser
const updateDcddUserRequest = (
  state: DcddUsers,
  action: UpdateDcddUserRequestAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const updateDcddUserSuccess = (
  state: DcddUsers,
  action: UpdateDcddUserSuccessAction
) => {
  const newUsers = state.dcddUserState.dcddUsers?.map((item) =>
    item.id === action.payload.user.id ? action.payload : item
  ) ?? [action.payload];
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    dcddUserState: {
      ...state.dcddUserState,
      dcddUsers: [...newUsers],
    },
  });
};

const updateDcddUserFail = (
  state: DcddUsers,
  action: UpdateDcddUserFailAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};
//updateDcddUserPassword
const updateDcddUserPasswordRequest = (
  state: DcddUsers,
  action: UpdateDcddUserPasswordRequestAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const updateDcddUserPasswordSuccess = (
  state: DcddUsers,
  action: UpdateDcddUserPasswordSuccessAction
) => {
  const newUsers = state.dcddUserState.dcddUsers?.map((item) =>
    item.id === action.payload.user.id ? action.payload : item
  ) ?? [action.payload];
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    dcddUserState: {
      ...state.dcddUserState,
      dcddUsers: [...newUsers],
    },
  });
};

const updateDcddUserPasswordFail = (
  state: DcddUsers,
  action: UpdateDcddUserPasswordFailAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};


//updateDcddIUserStatus
const updateDcddUserStatusRequest = (
  state: DcddUsers,
  action: UpdateDcddUserStatusRequestAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const updateDcddUserStatusSuccess = (
  state: DcddUsers,
  action: UpdateDcddUserStatusSuccessAction
) => {
 const updatedData =
    state.dcddUserState?.dcddUsers?.map((item) =>
      item.id === action.payload.id ? action.payload : item
    ) ?? [];
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
      dcddUsers: [...updatedData]
    },
    
  });
};

const updateDcddUserStatusFail = (
  state: DcddUsers,
  action: UpdateDcddUserStatusFailAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};
//bulkRegistration
const bulkRegistrationRequest = (
  state: DcddUsers,
  action: BulkRegistrationRequestAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const bulkRegistrationSuccess = (
  state: DcddUsers,
  action: BulkRegistrationSuccessAction
) => {
  const existingData = state.dcddUserState.dcddUsers ?? []
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    dcddUserState: {
      ...state.dcddUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
      dcddUsers: [...existingData,action.payload]
    },
    
  });
};

const bulkRegistrationFail = (
  state: DcddUsers,
  action: BulkRegistrationFailAction
) => {
  return updateObject(state, {
    genericDcddUserState: {
      ...state.genericDcddUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};
const DcddUserReducer = (state = initialState, action: DcddUserActions) => {
  switch (action.type) {
    case actionTypes.FETCH_DCDD_USERS_REQUEST:
      return FetchDcddUserRequest(state, action);
    case actionTypes.FETCH_DCDD_USERS_SUCCESS:
      return FetchDcddUserSuccess(state, action);
    case actionTypes.FETCH_DCDD_USERS_FAIL:
      return FetchDcddUserFail(state, action);
    case actionTypes.FETCH_DCDD_ACTIVE_USERS_REQUEST:
      return FetchDcddActiveUserRequest(state, action);
    case actionTypes.FETCH_DCDD_ACTIVE_USERS_SUCCESS:
      return FetchDcddActiveUserSuccess(state, action);
    case actionTypes.FETCH_DCDD_ACTIVE_USERS_FAIL:
      return FetchDcddActiveUserFail(state, action);
    case actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_REQUEST:
      return FetchDcddUserByDateRangeRequest(state, action);
    case actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_SUCCESS:
      return FetchDcddUserByDateRangeSuccess(state, action);
    case actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_FAIL:
      return FetchDcddUserByDateRangeFail(state, action);
    case actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_REQUEST:
      return FetchDcddUserProfileRequest(state, action);
    case actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_SUCCESS:
      return FetchDcddUserProfileSuccess(state, action);
    case actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_FAIL:
      return FetchDcddUserProfileFail(state, action);
    case actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_REQUEST:
      return checkForExistingUserByMobileRequest(state, action);
    case actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_SUCCESS:
      return checkForExistingUserByMobileSuccess(state, action);
    case actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_FAIL:
      return checkForExistingUserByMobileFail(state, action);
    case actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_REQUEST:
      return checkForExistingUserByEmailRequest(state, action);
    case actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_SUCCESS:
      return checkForExistingUserByEmailSuccess(state, action);
    case actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_FAIL:
      return checkForExistingUserByEmailFail(state, action);
    case actionTypes.FETCH_DZONGKHAG_REQUEST:
      return FetchDzongkhagRequest(state, action);
    case actionTypes.FETCH_DZONGKHAG_SUCCESS:
      return FetchDzongkhagSuccess(state, action);
    case actionTypes.FETCH_DZONGKHAG_FAIL:
      return FetchDzongkhagFail(state, action);
    case actionTypes.FETCH_SCHOOLS_REQUEST:
      return FetchSchoolsRequest(state, action);
    case actionTypes.FETCH_SCHOOLS_SUCCESS:
      return FetchSchoolsSuccess(state, action);
    case actionTypes.FETCH_SCHOOLS_FAIL:
      return FetchSchoolsFail(state, action);
    case actionTypes.FETCH_ECCD_REQUEST:
      return FetchEccdRequest(state, action);
    case actionTypes.FETCH_ECCD_SUCCESS:
      return FetchEccdSuccess(state, action);
    case actionTypes.FETCH_ECCD_FAIL:
      return FetchEccdFail(state, action);
    case actionTypes.FETCH_GRADES_REQUEST:
      return FetchGradesRequest(state, action);
    case actionTypes.FETCH_GRADES_SUCCESS:
      return FetchGradesSuccess(state, action);
    case actionTypes.FETCH_GRADES_FAIL:
      return FetchGradesFail(state, action);
    case actionTypes.CREATE_DCDD_USER_REQUEST:
      return createDcddUserRequest(state, action);
    case actionTypes.CREATE_DCDD_USER_SUCCESS:
      return createDcddUserSuccess(state, action);
    case actionTypes.CREATE_DCDD_USER_FAIL:
      return createDcddUserFail(state, action);
    case actionTypes.UPDATE_DCDD_USER_REQUEST:
      return updateDcddUserRequest(state, action);
    case actionTypes.UPDATE_DCDD_USER_SUCCESS:
      return updateDcddUserSuccess(state, action);
    case actionTypes.UPDATE_DCDD_USER_FAIL:
      return updateDcddUserFail(state, action);
    case actionTypes.UPDATE_DCDD_USER_PASSWORD_REQUEST:
      return updateDcddUserPasswordRequest(state, action);
    case actionTypes.UPDATE_DCDD_USER_PASSWORD_SUCCESS:
      return updateDcddUserPasswordSuccess(state, action);
    case actionTypes.UPDATE_DCDD_USER_PASSWORD_FAIL:
      return updateDcddUserPasswordFail(state, action);
    case actionTypes.UPDATE_DCDD_USER_STATUS_REQUEST:
      return updateDcddUserStatusRequest(state, action);
    case actionTypes.UPDATE_DCDD_USER_STATUS_SUCCESS:
      return updateDcddUserStatusSuccess(state, action);
    case actionTypes.UPDATE_DCDD_USER_STATUS_FAIL:
      return updateDcddUserStatusFail(state, action);
    case actionTypes.BULK_REGISTRATION_REQUEST:
      return bulkRegistrationRequest(state, action);
    case actionTypes.BULK_REGISTRATION_SUCCESS:
      return bulkRegistrationSuccess(state, action);
    case actionTypes.BULK_REGISTRATION_FAIL:
      return bulkRegistrationFail(state, action);
    case actionTypes.RESET_DCDD_DETAILS:
      return resetDcddDetails(state, action);
    default:
      return state;
  }
};

export default DcddUserReducer;
